<template>
  <div class="container mt-6">
    <generic-table
      ref="datatable"
      :title="$t('enterprises')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      resource_url="/system/enterprise/datatables"
    />

    <enterprise-modal ref="enterprise_modal" @success="refresh" />
  </div>
</template>

<script>
import EnterpriseModal from "./enterprise_modal/Index.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import { generate_datatables_buttons } from "@/utils";
import { confirm_deletion_dialog, del, error_message } from "@/utils";

export default {
  name: "AccessEnterprises",
  components: { GenericTable, EnterpriseModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add"),
          icon: "fa fa-plus",
          class: "is-secondary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          data: (row) => {
            return row.name || "";
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete enterprise?"),
                    v,
                    () => {
                      del("/system/enterprise", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  let uuid = e.detail.uuid;
                  v.$refs.enterprise_modal.edit_mode(uuid);
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.enterprise_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
  },
  mounted() {
    // let v = this;
    // v.init();
  },
};
</script>

<style></style>
